/**
 * `User-Agent` duet sends on its own server-to-WordPress requests, both REST and
 * GraphQL.
 *
 * These requests egress over the public community hostname, so they pass through
 * Fastly and are matched by its bot-blocking rules. duet must identify itself
 * rather than forward the inbound client's `User-Agent`: forwarding a blocked AI
 * crawler's value made Fastly reject duet's own backend calls with a 403, which
 * surfaced to the crawler as a 500 on otherwise-allowed `/sp/` paths.
 */
export const DUET_SERVER_USER_AGENT = "duet";

/**
 * Header carrying the originating caller's `User-Agent` on duet's
 * server-to-WordPress requests.
 *
 * The value was previously sent as `User-Agent` so WordPress-side load testing
 * could attribute traffic (voxmedia/duet#1515). It moved to a dedicated header so
 * that attribution survives without tripping Fastly's bot rules.
 */
export const CLIENT_USER_AGENT_HEADER = "x-duet-client-user-agent";
